import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7221e5cc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7221e5cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7221e5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7221e5cc')) {
      api.createRecord('7221e5cc', component.options)
    } else {
      api.reload('7221e5cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7221e5cc&scoped=true&", function () {
      api.rerender('7221e5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/news/index.vue"
export default component.exports